<template>
  <div>
    <p>{{ $t('text.unlicensed', this.$store.getters.patient )}}</p>
    <p v-if="enabledUntil">{{ $t('text.unlicensedEnd' )}}&nbsp;{{ enabledUntil | moment("D MMMM YYYY") }}.</p>
    <p v-if="patients.length > 1">{{ $t('text.switchBaby')}}</p>
    <p></p>
    <v-btn v-if="codeInviteEnabled" color="primary white--text ma-1" href="/new-activation">{{ $t('button.haveInviteCode')}}</v-btn>
    <v-btn v-if="patients.length > 1" color="primary white--text ma-1" href="/patientselector">{{ $t('button.switchBaby')}}</v-btn>
    <v-btn v-else color="primary white--text ma-1" href="https://www.mothchi.eu/">{{ $t('button.LeapStationWebsite')}}</v-btn>
  </div>
</template>

<script>
import i18n from "@/services/i18n";

export default {
  i18n:i18n,
  name: "neoparent-unlicensed",
  props: ["enabled-until"],
  methods: {
  },
  data() {
    return {
      patients: this.$store.getters.user.patients,
      codeInviteEnabled: false
    };
  },
  mounted() {
    const methods = this.user.hospital.inviteMethods.split(",")
    //check if code is in the list of methods
    this.codeInviteEnabled = methods.includes('code')
  }
}
</script>

<style scoped>

</style>
